import { FORM_TYPE } from './constants';

export const ppeDisplayNameById = id => {
  const [shortName] = Object.keys(FORM_TYPE)
    .filter(type => FORM_TYPE[type].ID === id)
    .map(type => FORM_TYPE[type].SHORT);
  return shortName;
};
